{
  "pt": {
    "snippets": {
      "labels": {
        "cancel": "Cancelar",
        "confirm": "Confirmar",
        "create": "Criar um trecho",
        "delete": "Eliminar",
        "edit": "Editar",
        "editTitle": "Editar trecho",
        "initMessage": "Selecione um trecho para visualizá-lo aqui.",
        "language": "Língua",
        "linkable": "Tipo",
        "linkableClient": "Equipa",
        "linkableEmployee": "Pessoal",
        "linkablePartner": "Parceiro",
        "manage": "Gerir os seus trechos",
        "manageMessage": "Ou clique aqui para gerir todos os seus trechos nas definições da empresa",
        "message": "Mensagem",
        "messageError": "Insira uma mensagem.",
        "new": "Novo trecho",
        "noSnippets": "Ainda não tem trechos de código.",
        "preview": "Pré-visualização",
        "save": "Guardar",
        "search": "Pesquisar",
        "select": "Selecione",
        "snippets": "Trechos",
        "title": "Título",
        "titleError": "Insira um título."
      }
    }
  }
}
